import styles from "./custom-progress-bar.module.scss";

const CustomProgressBar = ({ applicationOrders = [] }) => {
	const total = Array.isArray(applicationOrders) ? applicationOrders.length : 0;
	const finished =
		total === 0
			? 0
			: applicationOrders.filter((o) => {
					const state = o?.state_id ?? o?.application_orders_state_id ?? o?.state ?? o?.application_orders_state;
					return Number(state) === 5;
				}).length;

	const percent = total === 0 ? 0 : Math.round((finished / total) * 100);

	return (
		<div className={styles.progress}>
			<div className={styles.percent} aria-hidden>
				{percent}%
			</div>
			<div className={styles.track} aria-hidden>
				<div className={styles.fill} style={{ width: `${percent}%` }} />
			</div>
		</div>
	);
};

export default CustomProgressBar;
